import type { ReactNode } from 'react';

export const symbol_shift: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M320-150v-280H182q-19.36 0-27.18-17t4.18-32l298-371q8.88-11 22.94-11T503-850l298 371q12 15 4.18 32T778-430H640v280q0 12.75-8.62 21.37Q622.75-120 610-120H350q-12.75 0-21.37-8.63Q320-137.25 320-150Zm60-30h200v-310h133L480-786 247-490h133v310Zm100-310Z"
		/>
	</svg>
);
